<template>
  <div>
    <v-layout wrap>
      <v-flex>
        <br>
        <div style="padding: 0px 10px">
          <p class="font-weight-bold">
            Tên khung: {{ programName }}
          </p>
          <p class="font-weight-bold">
            Độ tuổi: {{ ageName }}
          </p>
          <p class="font-weight-bold">
            Level: {{ levelNumber }}
          </p>
          <p class="font-weight-bold">
            Số tuần học: {{ weekTotal }}
          </p>
        </div>
        <c-search-form
            :rows-per-page-items="[10, 20, 50]"
            :form-name="formName"
            :fields="fields"
            :hiddenFields="hiddenFields"
            key-property="weekId"
            :search-url="programId"
            create-url="/kidWeek/save"
            delete-url="/kidWeek/delete"
            form-type="intable"
            custom-create-new
            @createNew="openCreateDialog"
            custom-edit-item
            @editItem="openCreateDialog"
            ref="tableData"
            :reload="timeReload"
            :deleteMulti="false"
            orderBy="desc"
            :acceptBack="2"
            :acceptDelete="true"
            :accept-create="false"
            :acceptView="false"
            @viewItem="viewItem"
        >
        </c-search-form>
        <material-type-group-create
            :propsItem="category"
            :cDialog="visibleCreateDialog"
            @closeCreateDialog="closeCreateDialog"
            :formCreateName="formCreateName"
            :hiddenFields="hiddenFields"
        />
      </v-flex>
    </v-layout>
  </div>

</template>

<script>
import CSearchForm from "../../../components/form/ManageForm";
import {areaContants} from "@/constants";
import axios from "axios";
import MaterialTypeGroupCreate from "@/views/admin/week/WeekCreate";

export default {
  name: "warehouse",
  components: {MaterialTypeGroupCreate, CSearchForm},
  data: () => {
    return {
      formName: "Thông tin tuần học",
      formCreateName: "Thêm mới tuần học",
      category: null,
      visibleCreateDialog: false,
      timeReload: 0,
      programName: null,
      programId: null,
      ageId: null,
      ageName: null,
      levelNumber: null,
      levelId: null,
      weekTotal: null,
      hiddenFields: {
        typeId: "0",
      },
      fields: [
/*        {
          value: "index",
          text: "lang.common.index",
          width: "5%",
          sortable: false,
          headerStyle: "text-align:center",
        },*/
        {
          value: 'weekOrder',
          text: 'Số thứ tự tuần',
          sortable: false,
          search: true,
          width: "5%",
          headerStyle: "text-align:center",
        },
        {
          value: 'weekName',
          text: 'Tên tuần học',
          sortable: false,
          search: true,
          width: "20%",
          headerStyle: "text-align:center",
        },

        {
          value: 'unitId',
          text: 'Tên bài',
          width: "15%",
          sortable: false,
          search: true,
          headerStyle: "text-align:center",
          type: "select",
          name: "unitId",
          items: [],
          itemText: "unitName",
          itemValue: "unitId",
        },
        {
          value: 'missionId',
          text: 'Tên nhiệm vụ',
          width: "15%",
          sortable: false,
          search: true,
          headerStyle: "text-align:center",
          type: "select",
          name: "missionId",
          items: [],
          itemText: "missionName",
          itemValue: "missionId",
        },
       /* {
          value: "action",
          text: "lang.common.actions",
          sortable: false,
          compound: true,
          width: "15%",
          headerStyle: "text-align:center",
        },*/
      ],
    };
  },

  created() {
    this.programId = "/kidWeek/search/"+ this.$route.params.id + "?sortField=status,weekOrder&";

      axios.post(
          process.env.VUE_APP_API_URL + "/kidProgram/listAllName", {programId: this.$route.params.id, status: 1}
      )
          .then(
              (data) => {
                if (data.length > 0) {
                  for (let i = 0; i < data.length; i++) {
                    if (data[i].programId == this.$route.params.id) {
                      this.programName = data[i].programName;
                      this.getRequestkidAge(data[i].ageId);
                      this.getRequestkidLevel(data[i].levelId);
                      this.weekTotal = data[i].weekTotal;
                    }
                  }
                }
              }
          );
    axios.post(
        process.env.VUE_APP_API_URL + "/kidUnit/listAllName", {status: 1}
    )
        .then(
            (data) => {
              let itemFields = this.fields.filter(function (e) {
                return e.name == "unitId";
              });
              if (itemFields != undefined && itemFields.length > 0) {
                itemFields[0].items = data;
              }
            }
        );

    axios.post(
        process.env.VUE_APP_API_URL + "/kidMission/listAllName", {status: 1}
    )
        .then(
            (data) => {
              let itemFields = this.fields.filter(function (e) {
                return e.name == "missionId";
              });
              if (itemFields != undefined && itemFields.length > 0) {
                itemFields[0].items = data;
              }
            }
        );
  },


  methods: {

    getRequestkidLevel(id) {
      axios.post(
          process.env.VUE_APP_API_URL + "/kidLevel/listAllName", {levelId: id, status: 1}
      )
          .then(
              (data) => {
                if (data.length > 0) {
                  for (let i = 0; i < data.length; i++) {
                    if (data[i].levelId == id) {
                      this.levelNumber = data[i].levelNumber;
                    }
                  }
                }
              }
          );
    },
    getRequestkidAge(id) {
      axios.post(
          process.env.VUE_APP_API_URL + "/kidAge/listAllName", {ageId: id, status: 1}
      )
          .then(
              (data) => {
                if (data.length > 0) {
                  for (let i = 0; i < data.length; i++) {
                    if (data[i].ageId == id) {
                      this.ageName = data[i].ageName;
                    }
                  }
                }
              }
          );
    },
    openCreateDialog: function (item = null) {
      if (item == null) {
        this.formCreateName = 'Thêm mới tuần học';
        this.getNextCode();
      } else {
        this.category = item;
        this.formCreateName = 'Cập nhật tuần học';
        this.visibleCreateDialog = true;
      }
    },
    closeCreateDialog: function () {
      this.category = null;
      this.visibleCreateDialog = false;
      this.timeReload = Math.floor(Math.random() * 100);
    },

    getNextCode: function () {
      axios.get(
          process.env.VUE_APP_API_URL +
          "/autoIncrease/getNextNumber?type=MATERIAL_TYPE_ALLY"
      )
          .then((data) => {
            this.category = Object.assign({}, this.category, {"categoryCode": "MATERIAL_TYPE_ALLY" + data, "status": 1})
            this.visibleCreateDialog = true;
          });
    },
    createParamLastSearch: function (values) {
      const obj1 = {
        searchImportRequest: JSON.stringify(values),
      };
      const obj2 = this.$route.query;
      return {...obj1, ...obj2};
    },
    viewItem: function (item) {
      this.$router.push({
        path: '/program/view/' + item.programId,
        query: this.createParamLastSearch(this.lastSearchValues)
      });
    },
  },

  destroyed() {
  },
};
</script>
